/** @jsx jsx */
import React from 'react';
import { jsx } from '@balance-web/core';
import type { DeprecatedButtonProps } from '@balance-web/button-deprecated';
import { DeprecatedButton } from '@balance-web/button-deprecated';
import type { FlexProps } from '@balance-web/flex';
import { Flex } from '@balance-web/flex';

export type Action = DeprecatedButtonProps &
  JSX.IntrinsicAttributes & {
    action: CallableFunction;
  };

export type ActionFooterProps = FlexProps & {
  size?: Action['size'];
  isInsideDrawer?: boolean;
  actions: (Action | undefined)[];
};

export function ActionFooter({
  actions,
  size,
  gap = 'medium',
  isInsideDrawer,
  ...flexProps
}: ActionFooterProps) {
  return (
    <Flex {...flexProps} gap={gap}>
      {actions
        .filter((action): action is Action => {
          return !!action;
        })
        .map(({ action, label, weight, tone, ...props }, index) => {
          return (
            <DeprecatedButton
              label={label}
              key={label}
              size={props.size || size || 'small'}
              onClick={() => {
                return action();
              }}
              css={{ minWidth: 304 }}
              weight={index ? 'none' : (isInsideDrawer && 'subtle') || 'bold'}
              tone={(index && 'active') || undefined}
              {...props}
            />
          );
        })}
    </Flex>
  );
}
